import { createContext, useContext } from 'react'

import type { EviePageFactsHandle } from 'src/components/Evie/page/hooks/useEviePageFacts'

/** One enrollment/facts read for the route dispatcher and product surface.
 * Missing context is an error, never a silent fallback to legacy Eve. */
export const EviePageFactsContext = createContext<EviePageFactsHandle | null>(
  null
)

export const useEviePageFactsContext = () => {
  const handle = useContext(EviePageFactsContext)
  if (!handle) {
    throw new Error(
      'useEviePageFactsContext must be used under ApplicantSessionLayout (or an explicit EviePageFactsContext.Provider in tests)'
    )
  }
  return handle
}
